// extracted by mini-css-extract-plugin
export default {"main":"ListItem_main__EtRBu","pointer":"ListItem_pointer__fnxm4","text":"ListItem_text__eNf6y"};